import { array, number, object, string } from "yup";
import { isExists } from "../../../../utils";
import {
  lineEnum,
  newTypeEnum,
  paymentTypeEnum,
  productCategoryEnum,
  serviceTypeEnum,
} from "../../../../utils/enum";

const serviceValidationSchema = object({
  categoryId: string().test(
    "Lütfen ürün kategorisi seçiniz",
    "Lütfen ürün kategorisi seçiniz",
    function () {
      if (this.parent.orderLines.length <= 0) {
        return isExists(this.parent.categoryId);
      } else {
        return true;
      }
    }
  ),
  productTypeId: string().test(
    "Lütfen ürün tipi seçiniz",
    "Lütfen ürün tipi seçiniz",
    function () {
      if (this.parent.orderLines.length <= 0) {
        if (
          Number(this.parent.categoryId) ===
          Number(productCategoryEnum.voiceService)
        ) {
          return isExists(this.parent.productTypeId);
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  ),
  campaign: string().test(
    "Lütfen kampanya seçiniz",
    "Lütfen kampanya seçiniz",
    function () {
      if (this.parent.orderLines.length <= 0) {
        return isExists(this.parent.campaign);
      } else {
        return true;
      }
    }
  ),
  paymentType: number()
    .test(
      "Lütfen işlem türü seçiniz",
      "Lütfen işlem türü seçiniz",
      function () {
        if (this.parent.orderLines.length <= 0) {
          return isExists(this.parent.paymentType);
        } else {
          return true;
        }
      }
    )
    .nullable(),
  newType: number()
    .test(
      "Lütfen internet türü seçiniz",
      "Lütfen internet türü seçiniz",
      function () {
        if (
          Number(this.parent.categoryId) !== productCategoryEnum.connectService
        ) {
          return true;
        }

        return isExists(this.parent.newType);
      }
    )
    .nullable(),
  phoneInternet: string().test(
    "Lütfen Sabit Numara giriniz",
    "Lütfen Sabit Numara giriniz",
    function () {
      if (
        Number(this.parent.categoryId) ===
          Number(productCategoryEnum.connectService) &&
        (Number(this.parent.newType) === newTypeEnum.internet ||
          Number(this.parent.newType) === newTypeEnum.inter_fttx)
      ) {
        return isExists(this.parent.phoneInternet);
      } else {
        return true;
      }
    }
  ),
  hatType: number()
    .test("Lütfen hat tipi seçiniz", "Lütfen hat tipi seçiniz", function () {
      if (
        Number(this.parent.categoryId) === productCategoryEnum.connectService &&
        Number(this.parent.paymentType) === paymentTypeEnum.churn
      ) {
        return isExists(this.parent.hatType);
      } else {
        return true;
      }
    })
    .nullable(),
  servicePhone: string()
    .test(
      "Lütfen Sabit Numara giriniz",
      "Lütfen Sabit Numara giriniz",
      function () {
        if (
          Number(this.parent.categoryId) ===
            Number(productCategoryEnum.connectService) &&
          (Number(this.parent.paymentType) === paymentTypeEnum.churn ||
            Number(this.parent.paymentType) === paymentTypeEnum.new) &&
          Number(this.parent.hatType) === lineEnum.fixed_line
        ) {
          return isExists(this.parent.servicePhone);
        } else {
          return true;
        }
      }
    )
    .nullable(),
  devreNo: string()
    .test(
      "Lütfen Devre Numarası giriniz",
      "Lütfen Devre Numarası giriniz",
      function () {
        if (
          Number(this.parent.categoryId) ===
            Number(productCategoryEnum.connectService) &&
          Number(this.parent.paymentType) === paymentTypeEnum.churn &&
          (Number(this.parent.hatType) === lineEnum.fixed_line ||
            Number(this.parent.hatType) === lineEnum.lean_line)
        ) {
          return isExists(this.parent.devreNo);
        } else {
          return true;
        }
      }
    )
    .nullable(),
  serviceType: string().test(
    "Lütfen Ürün tipi giriniz",
    "Lütfen Ürün tipi giriniz",
    function () {
      if (
        Number(this.parent.categoryId) ===
          Number(productCategoryEnum.voiceService) &&
        Number(this.parent.paymentType) !== paymentTypeEnum.new
      ) {
        return isExists(this.parent.serviceType);
      } else {
        return true;
      }
    }
  ),
  pstnPhoneNumbers: array().of(
    object().shape({
      phone: string().test(
        "Lütfen Telefon Numarası giriniz",
        "Lütfen Telefon Numarası giriniz",
        function () {
          const schema: any = this;
          if (schema.from[1].value.orderLines.length <= 0) {
            if (
              Number(schema.from[1].value.categoryId) ===
                Number(productCategoryEnum.voiceService) &&
              Number(schema.from[1].value.paymentType) !==
                paymentTypeEnum.new &&
              Number(schema.from[1].value.serviceType) === serviceTypeEnum.pstn
            ) {
              return isExists(this.parent.phone);
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      ),
      range: string().test(
        "Lütfen Numara Aralığı giriniz",
        "Lütfen Numara Aralığı giriniz",
        function () {
          const schema: any = this;
          if (schema.from[1].value.orderLines.length <= 0) {
            if (
              Number(schema.from[1].value.categoryId) ===
                Number(productCategoryEnum.voiceService) &&
              Number(schema.from[1].value.paymentType) !==
                paymentTypeEnum.new &&
              Number(schema.from[1].value.serviceType) === serviceTypeEnum.pstn
            ) {
              return isExists(this.parent.range);
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      ),
    })
  ),
  bri: array().of(
    object().shape({
      phone: string().test(
        "Lütfen Telefon Numarası giriniz",
        "Lütfen Telefon Numarası giriniz",
        function () {
          const schema: any = this;
          if (schema.from[1].value.orderLines.length <= 0) {
            if (
              Number(schema.from[1].value.categoryId) ===
                Number(productCategoryEnum.voiceService) &&
              Number(schema.from[1].value.serviceType) ===
                serviceTypeEnum.bri &&
              Number(schema.from[1].value.paymentType) !== paymentTypeEnum.new
            ) {
              return isExists(this.parent.phone);
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      ),
      block: string().test(
        "Lütfen Bri numara bloğu giriniz",
        "Lütfen Bri numara bloğu giriniz",
        function () {
          const schema: any = this;
          if (
            Number(schema.from[1].value.categoryId) ===
              Number(productCategoryEnum.voiceService) &&
            Number(schema.from[1].value.serviceType) === serviceTypeEnum.bri &&
            Number(schema.from[1].value.paymentType) !== paymentTypeEnum.new
          ) {
            return isExists(this.parent.block);
          } else {
            return true;
          }
        }
      ),
      didcount: string().test(
        "Lütfen DID Sayısı giriniz",
        "Lütfen DID Sayısı giriniz",
        function () {
          const schema: any = this;
          if (
            Number(schema.from[1].value.categoryId) ===
              Number(productCategoryEnum.voiceService) &&
            Number(schema.from[1].value.serviceType) === serviceTypeEnum.bri &&
            Number(schema.from[1].value.paymentType) !== paymentTypeEnum.new
          ) {
            return isExists(this.parent.didcount);
          } else {
            return true;
          }
        }
      ),
    })
  ),
  pri: array().of(
    object().shape({
      phone: string().test(
        "Lütfen Telefon Numarası giriniz",
        "Lütfen Telefon Numarası giriniz",
        function () {
          const schema: any = this;
          if (
            Number(schema.from[1].value.categoryId) ===
              Number(productCategoryEnum.voiceService) &&
            Number(schema.from[1].value.serviceType) === serviceTypeEnum.pri &&
            Number(schema.from[1].value.paymentType) !== paymentTypeEnum.new
          ) {
            return isExists(this.parent.phone);
          } else {
            return true;
          }
        }
      ),
      block: string().test(
        "Lütfen Pri numara bloğu giriniz",
        "Lütfen Pri numara bloğu giriniz",
        function () {
          const schema: any = this;
          if (
            Number(schema.from[1].value.categoryId) ===
              Number(productCategoryEnum.voiceService) &&
            Number(schema.from[1].value.serviceType) === serviceTypeEnum.pri &&
            Number(schema.from[1].value.paymentType) !== paymentTypeEnum.new
          ) {
            return isExists(this.parent.block);
          } else {
            return true;
          }
        }
      ),
      /* didcount: string().test(
        "Lütfen DID Sayısı giriniz",
        "Lütfen DID Sayısı giriniz",
        function () {
          const schema: any = this;
          if (
            Number(schema.from[1].value.categoryId) ===
              Number(productCategoryEnum.voiceService) &&
            Number(schema.from[1].value.serviceType) === serviceTypeEnum.pri &&
            Number(schema.from[1].value.paymentType) !== paymentTypeEnum.new
          ) {
            return isExists(this.parent.didcount);
          } else {
            return true;
          }
        }
      ), */
    })
  ),
  /* customerManagementGroupIds: array()
    .nullable(true)
    .min(1, "Lütfen Süreç seçiniz.")
    .test("Lütfen Süreç seçiniz", "Lütfen Süreç seçiniz", function () {
      if (this.parent.orderLines.length <= 0) {
        return isExists(this.parent.customerManagementGroupIds);
      } else {
        return true;
      }
    }),
  ddtechType: number().test(
    "Lütfen iş emri tipi seçiniz",
    "Lütfen iş emri tipi seçiniz",
    function () {
      console.log(this.parent);
      if (this.parent.orderLines.length <= 0) {
        return isExists(this.parent.ddtechType);
      } else {
        return true;
      }
    }
  ), */
  orderLines: array().min(1, "Lütfen en az bir adet sipariş kalemi ekleyin."),
});

export default serviceValidationSchema;
